import type { ComponentProps } from "react";
import { AvatarImage } from "@/components/ui/avatar";
import { useSignedAssetUrl } from "@/hooks/use-signed-asset";

// AvatarImage that understands private-bucket references (bot avatars
// uploaded via /uploads): signs them first, passes Feishu URLs through.
// Drop-in for <AvatarImage src=…>; the sibling AvatarFallback shows while
// the signed URL is loading, exactly as for a missing avatar.
export const SignedAvatarImage = ({
  src,
  ...rest
}: ComponentProps<typeof AvatarImage>) => {
  const resolved = useSignedAssetUrl(src);
  return <AvatarImage src={resolved} {...rest} />;
};

export default SignedAvatarImage;
